import { image, title, tr } from "framer-motion/client";

export const personalData = {
  name: "Dejan Stanojević",
  title: "Student at Faculty of Technical Sciences, University of Novi Sad",
  bio: "Building digital experiences that matter",
  description: "Passionate developer specializing in AI/ML and modern web technologies. Creating innovative solutions that make a difference.",
  email: "dejanstanojevic461@gmail.com",
  phone: "+387 66 198 737",
  location: "Novi Sad, Serbia",
  
  profileImage: "../images/profile.jpg",
  
  // DRUŠTVENE MREŽE
  social: {
    linkedin: "https://linkedin.com/in/dejan-stanojević-49981631a",
    instagram: "https://www.instagram.com/stanoojeviic/",
    //github: "https://github.com/dejanstanojevic", // Dodaj svoj GitHub username
    // twitter: "https://twitter.com/username", // Dodaj ako imaš
    // facebook: "https://facebook.com/username", // Dodaj ako imaš
  },
  

  
  stats: [
    { value: "20+", label: "Projects" },
    { value: "4+", label: "Years of Experience" },
    { value: "10+", label: "Satisfied Clients" },
    { value: "∞", label: "Cups of Coffee" }
  ],
  
  skills: {
    frontend: [
      { name: "React/Next.js", level: 85, icon: "⚛️", color: "#61DAFB" },
      { name: "TypeScript", level: 80, icon: "📘", color: "#3178C6" },
      { name: "Tailwind CSS", level: 95, icon: "🎨", color: "#06B6D4" },
      { name: "Three.js", level: 75, icon: "🎮", color: "#049EF4" }
    ],
    backend: [
      { name: "Node.js", level: 75, icon: "🚀", color: "#339933" },
      { name: "Python", level: 85, icon: "🐍", color: "#3776AB" },
      { name: "SQL", level: 80, icon: "🗄️", color: "#4479A1" },
      { name: "FastAPI", level: 70, icon: "⚡", color: "#009688" }
    ],
    ai_ml: [
      { name: "AI/ML", level: 90, icon: "🤖", color: "#FF6B35" },
      { name: "TensorFlow", level: 75, icon: "🧠", color: "#FF6F00" },
      { name: "OpenCV", level: 70, icon: "👁️", color: "#5C3EE8" }
    ],
    soft: [
      { name: "Problem Solving", level: 100, icon: "🧠", color: "#10B981" },
      { name: "Teamwork", level: 100, icon: "🤝", color: "#10B981" },
      { name: "Communication", level: 90, icon: "💬", color: "#10B981" }
    ]
  }
};

export const education = [
  {
    id: 1,
    degree: "Tehničar informacionih tehnologija",
    institution: "Elektrotehnička škola Prijedor",
    period: "2021 - 2025",
    image: "/images/education/ets.jpg",
    description: "Specialization in software development and IT systems",
    achievements: ["Multiple programming competitions winner", "One of the best students of the generation"]
  },
  {
    id: 2,
    image: "/images/education/ftn.jpg",
    degree: "Bachelor in Power Software Engineering",
    institution: "Faculty of Technical Sciences, University of Novi Sad",
    period: "2025 - Present",
    description: "Focused on software engineering principles, algorithms, and system design",
    achievements: ["Student Projects", "Active in student organizations"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Zaštitnik potrošača",
    description: "Mobile app for consumers to help them make informed decisions and protect their rights",
    longDescription: "Comprehensive consumer protection platform that helps users understand their rights, report issues, and get legal advice. Features include AI-powered legal assistant, document templates, and direct connection to consumer protection agencies.",
    tech: ["Next.js", "TypeScript", "Tailwind", "EmailJS", "PostgreSQL"],
    features: ["Consumer Protection", "Educational Resources", "Legal Connection", "Community Forum", "AI Assistant"],
    image: "📱",
    demoVideo: "/images/PromoVideoPotrosaci.mp4",
    imageUrl: "/images/ikonica.png",
    //github: "https://github.com/dejanstanojevic/zastitnik-potrosaca",
    //demo: "https://zastitnik-potrosaca.demo",
    featured: false
  },
  {
    id: 2,
    title: "MyBusPD",
    description: "Mobile app for public transportation with real-time tracking",
    longDescription: "Comprehensive transit solution with live bus tracking, route optimization, and user-friendly interface. Helps citizens navigate public transport efficiently with real-time updates and notifications.",
    tech: ["React Native", "FastAPI", "Node.js", "PostgreSQL", "WebSockets", "Google Maps API"],
    features: ["Live Bus Tracking", "Route Optimization", "Push Notifications", "Trip History", "Analytics Dashboard"],
    image: "🚌",
    demoVideo: "/images/PromoVideoPD.mp4",
    imageUrl: "/images/logo.png",
    //github: "https://github.com/dejanstanojevic/mybuspd",
    //demo: "https://mybuspd.demo",
    featured: true
  },
  {
    id: 3,
    title: "DivaS Website",
    description: "Webshop for shoes and accessories",
    longDescription: "E-commerce platform with seamless shopping experience, personalized recommendations, and secure checkout. Features include product catalog, shopping cart, user accounts, and order tracking.",
    tech: ["Three.js", "React", "Node.js", "PostgreSQL", "Stripe", "Email"],
    features: ["Online Store", "3D Product View", "Shopping Cart", "User Authentication", "Order Management"],
    image: "🌐",
    imageUrl: "/images/divas.png",
    //github: "https://github.com/dejanstanojevic/divas",
    demo: "https://divas.rs/",
    featured: false
  },
  {
    id: 4,
    title: "Alerta",
    description: "Mobile app for emergency response and disaster management",
    longDescription: "Comprehensive emergency response platform that connects citizens with first responders. Features include real-time alerts, resource mapping, and communication tools to improve disaster response and community safety.",
    tech: ["React Native", "Node.js", "PostgreSQL", "WebSockets", "Google Maps API"],
    features: ["Real-Time Alerts", "Resource Mapping", "Emergency Communication", "User Profiles", "Analytics Dashboard"],
    image: "🚨",
    imageUrl: "/images/logo3.png",
    //github: "
    demoVideo: "/images/PromoVideoV2.mp4",
    featured: true
  },
  {
    id: 5,
    title: "Smart garage door control system",
    description: "IoT-based solution for remote control and monitoring of garage doors",
    longDescription: "Innovative smart garage door control system that allows users to remotely open, close, and monitor their garage doors via a mobile app. Features include real-time notifications, integration with home automation systems, and secure access control.",
    tech: ["React Native", "Node.js", "PostgreSQL", "WebSockets", "IoT Sensors"],
    features: ["Remote Control", "Real-Time Monitoring", "Integration with Home Automation", "Secure Access Control", "Push Notifications"],
    image: "🏠",
    imageUrl: "/images/achievements/inost3.jpg",
    //github: "https://github.com/dejanstanojevic/smart-garage-door",
    demoVideo: "/images/PromoVideoInost.mp4",
    featured: true
  },
  {
    id: 6,
    title: "AI-powered satellite tracking system",
    description: "AI solution for monitoring space debris and improving space safety",
    longDescription: "Innovative AI-powered satellite tracking system designed to monitor space debris and improve space safety. Utilizes machine learning algorithms to predict satellite trajectories and potential collisions, providing real-time alerts and data visualization.",
    tech: ["3D Modeling", "Node.js", "Three.js", "TensorFlow", "Google Cloud Platform"],
    features: ["AI-Powered Tracking", "Real-Time Alerts", "Data Visualization", "Predictive Analytics", "Integration with Space Agencies"],
    image: "🛰️",
    imageUrl: "/images/achievements/PARIS6.jpg",
    //github: "https://github.com/dejanstanojevic/ai-satellite-tracking",
    demoVideo: "/images/PromoVideoAI.mp4",
    featured: true
  },
  {
    id: 7,
    title: "AI-powered shark tracking system",
    description: "Innovative solution for monitoring shark movements using satellite data",
    longDescription: "Innovative AI-powered shark tracking system designed to monitor shark movements and improve marine conservation efforts. Utilizes satellite data and machine learning algorithms to provide real-time insights and predictive analytics.",
    tech: ["3D Modeling", "Node.js", "Three.js", "Blender", "TensorFlow", "Google Cloud Platform", "WebSockets"],
    features: ["AI-Powered Tracking", "Real-Time Alerts", "Data Visualization", "Predictive Analytics", "Integration with Marine Research Institutes"],
    image: "🦈",
    imageUrl: "/images/lisbon.jpg",
    //github: "https://github.com/dejanstanojevic/ai-shark-tracking",
    demoVideo: "/images/PromoVideoShark.mp4",
    featured: true
  }
];

  export const experiences = [
    // MENTORSTVA
    {
      id: 1,
      title: "Mentor at PREDA Hackathon",
      organization: "Razvojna agencija PREDA",
      year: "2026",
      backgroundImage: "/images/achievements/preda.jpg",
      type: "mentorship",
      icon: "👨‍🏫",
      description: "Mentored high school students in web development fundamentals, helping them build their projects and guiding them through the hackathon process.",
      location: "Prijedor, BiH",
      //achievements: ["3 winning projects", "Best mentor award"]
    },
    {
      id: 2,
      title: "BHFF Ignite program",
      organization: "Bosnia & Herzegovina Futures Foundation",
      backgroundImage: "/images/achievements/ignite.png",
      year: "2025",
      type: "volunteering",
      icon: "🎓",
      description: "I was a member of the BHFF Ignite program, where I participated in workshops, mentorship sessions, and networking events focused on entrepreneurship and innovation. I also contributed to community projects and initiatives aimed at fostering a culture of innovation in Bosnia and Herzegovina.",
      location: "Sarajevo, BiH",
      achievements: ["Certificate of completion", "Selected among top participants"] 
    },
    
    // VOLONTIRANJA
    {
      id: 3,
      title: "FUTURE LEADERS SUMMIT 2025",
      organization: "Bosnia & Herzegovina Futures Foundation",
      year: "2025",
      backgroundImage: "/images/achievements/bhff.png",
      type: "event",
      icon: "🚀",
      description: "Participated at the Future Leaders Summit 2025, a prestigious event organized by the Bosnia & Herzegovina Futures Foundation. The summit brought together young leaders, innovators, and changemakers from across the country to discuss and collaborate on solutions for a better future. I had the opportunity to attend inspiring talks, engage in workshops, and network with like-minded individuals who are passionate about making a positive impact in our society.",
      location: "Sarajevo, BiH",
      achievements: ["250+ participants", "Learned event management skills", "Networked with industry leaders"]
    },
    {
      id: 4,
      title: "PowerIT 2026 — Schneider Electric",
      organization: "Schneider Electric Serbia",
      year: "2026",
      backgroundImage: "/images/achievements/schnider.jpg",
      type: "event",
      icon: "💡",
      description: "I attended PowerIT 2026 in Novi Sad, organised by Schneider Electric. Through talks and a hands-on workshop, I expanded my knowledge of artificial intelligence, quantum computing, data centre infrastructure and team decision-making.",
      location: "Novi Sad, Serbia",
      achievements: [
        "Keynote: “When ChatGPT Takes the Floor — Speak Like a Human, Use AI as a Tool” by Radovan Perović.",
        "Keynote on what AI knows about us and our data by Ulrich Hüstert and Anita Sommer.",
        "“Quantum Computing — When Strong Encryption Is Not Enough” by Milen Miodanić.",
        "“Data Centre Infrastructure of the Future in the AI Era” by Dušan Ćirić.",
        "“Why Do Good Teams Make Bad Decisions?” by Nevena Batinić Pokrajac.",
        "Workshop: “From Vibe Coding to Thought Engineering” by Šandor Beretka, exploring AI-native development through play and self-assessment."
      ]
    },
    {
      id: 5,
      title: "Codeference 2026 — Technology & AI Conference",
      organization: "Codeference",
      year: "2026",
      backgroundImage: "/images/achievements/smartgrid4.jpg",
      type: "event",
      icon: "💻",
      location: "Zlatibor, Serbia",
      description:
        "I attended Codeference 2026 at Zlatibor, taking part in talks, discussions and networking activities focused on artificial intelligence, modern software development, entrepreneurship and the future of programming. I also participated in the SMARTGRID Hackathon, where our team won first place.",
      achievements: [
        "Codecast: From FTN to Founder — Danilo Bajić, Underpond. A discussion about the journey from university to founding a technology company.",
        "Agentic Search: From Capable Models to Useful, Checkable Work — Nikola Trifunović, Perplexity AI.",
        "Spec-Driven Development: From Idea to Code with AI — Jelena Marković, Orion Innovation.",
        "Our First AI Colleague: Meet Barley — Sergey Zakirov, Igor Dobrić, Provectus.",
        "CodeFair — technology exhibition and networking.",
        "Panel discussion: Is AI the Last Generation of Programmers?",
        "SMARTGRID Hackathon — 1st Place."
      ]
    },
    
    
  ];
// Dodaj na kraju fajla, nakon blogPosts (ili zamijeni blogPosts)

export const mediaContent = {
  // Video intervjui (YouTube, Vimeo, itd.)
  videos: [
    {
      id: 1,
      title: "NASA Space Apps Challenge Paris - Interview about our AI satellite tracking project",
      platform: "YouTube",
      url: "https://www.youtube.com/embed/9z8l0dNm_Tw", // Zamijeni sa svojim linkom
      thumbnail: "../images/audio.jpg",
      duration: "02:00",
      description: "Interview about our project that won third place at the NASA Space Apps Challenge in Paris, where we developed an AI-powered satellite tracking system to help monitor space debris and improve space safety.",
      date: "Oct 20, 2024",
      type: "TV Interview"
    },

  ],

  // Članci i reportaže o meni
  articles: [
    {
      id: 1,
      title: "Students from Republika Srpska won third place at the NASA competition in Paris",
      publication: "Nezavisne novine",
      author: "N.N.",
      date: "October 13, 2024",
      url: "https://www.nezavisne.com/novosti/drustvo/Djaci-iz-Srpske-osvojili-trece-mjesto-na-takmicenju-NASA-u-Parizu/862635",
      excerpt: "Dejan Stanojević, a student at the Faculty of Electrical Engineering in Banja Luka, together with his team won third place at the prestigious NASA Space Apps Challenge competition held in Paris. Their innovative AI satellite tracking project impressed the jury and competitors from around the world.",
      image: "images/profile.jpg",
      category: "Success Story"
    },
    {
      id: 2,
      title: "Top 5 app in Bosnia and Herzegovina in the Mtel app competition",
      publication: "Mtel App Competition",  
      url: "https://apptakmicenje.mtel.ba/prethodni-ciklusi-pregled/8-m-tel-app-takmicenje",
      author: "Mtel",
      date: "March 20, 2025",
      excerpt: "Our app Alerta was selected as one of the top 5 apps in Bosnia and Herzegovina in the Mtel app competition, showcasing our innovative solution for emergency response systems.",
      image: "https://apptakmicenje.mtel.ba/wp-content/uploads/2025/03/app-takmicenje-2025.jpg",
      category: "Achievement"
    },
    {
      id: 3,
      title: "Great success of former graduates of the Electrical Engineering School at our hackathon in Lisbon",
      publication: "Kozarski vjesnik",
      author: "Tanja Mandić",
      date: "October 14, 2025",
      url: "https://kozarski.com/veliki-uspjeh-bivsih-maturanata-elektrotehnicke-skole-na-nasa-hakatonu-u-lisabonu/",
      excerpt: "Great success of former graduates of the Electrical Engineering School at hackathon in Lisbon with an AI-powered shark tracking system using satellite data, demonstrating the innovative spirit and talent nurtured at the Electrical Engineering School.",
      image: "	https://kozarski.com/wp-content/uploads/2025/10/elektro-696x522.jpg",
      category: "Success Story"
    },
    {
      id: 4,
      title: "Another success for the young programmer at Inost in Banja Luka",
      publication: "SRNA",
      author: "Katarina Panić",
      date: "February 10, 2025",
      url: "https://freeradioprijedor.com/elektrotehnicka-skola-na-inostu-mladih-osvojili-12-nagrada-medju-kojima-tri-zlatne-plakete/",
      excerpt: "First place at Inost in Banja Luka with an AI - powered gate control system for smart cities...",
      image: "https://freeradioprijedor.com/wp-content/uploads/2025/04/Srn2025-4-29_183729_1-1024x682-1.jpg",
      category: "Achievement"
    },
    {
      id: 5,
      title: "Partnership in the sign of innovation: Successfully completed hackathon 'Strategy - We Solve Problems' in Banja Luka",
      publication: "MF Bank Blog",
      author: "MF Bank",
      date: "December 12, 2025",
      url: "https://www.facebook.com/MFbanka/posts/-partnerstvo-u-znaku-inovacija-uspje%C5%A1no-zavr%C5%A1en-hackathonstrategija-rje%C5%A1avamo-od/1453472843448779/",
      excerpt: "Second place at Banja Luka Hackathon with an AI agent for improving customer service in banking...",
      image: "https://via.placeholder.com/400x200",
      category: "Achievement"
    }
  ],
  // Podcast i audio intervjui
  podcasts: [
    {
      id: 1,
      title: "Our story: A young programmer from Bosnia and Herzegovina wins the NASA hackathon",
      platform: "BHRT OP Podcast",
      url: "https://op.bhrt.ba/wp-content/uploads/2024/10/3.-MJESTO-NASA_mixdown.mp3",
      //embedUrl: "https://op.bhrt.ba/wp-content/uploads/2024/10/3.-MJESTO-NASA_mixdown.mp3",
      duration: "08:08",
      description: "The story of my journey from high school programmer to NASA hackathon winner, challenges and plans for the future.",
      date: "Oct 24, 2024"
    },
    {
      id: 2,
      title: "Mtel App Competition - Interview about our top 5 app in Bosnia and Herzegovina",
      platform: "Youtube Podcast",
      url: "https://youtu.be/alhRICYq4zA?si=XZd45NGl_jQ7HKsV",
      //embedUrl: "https://youtu.be/alhRICYq4zA?si=XZd45NGl_jQ7HKsV",
      duration: "29:17",
      description: "Interview about our app that was selected as one of the top 5 apps in Bosnia and Herzegovina in the Mtel app competition.",
      date: "Mar 20, 2025"
    },
    {
      id: 3,
      title: "Podcast about our project that won the third place at Nasa Space Apps Challenge in Paris",
      platform: "Youtube Podcast",
      url: "https://youtu.be/xwht3FRRFtM?si=iRVV7DlJ7DcI9O-j",
     // embedUrl: "../images/audio.jpg",
      duration: "31:23",
      description: "Podcast about our project that won the third place at Nasa Space Apps Challenge in Paris, where we developed an AI-powered satellite tracking system to help monitor space debris and improve space safety.",
      date: "Oct 17, 2024"
    },
    {
      id: 4,
      title: "Best of the best",
      platform: "Youtube Podcast",
      url: "https://youtu.be/xEB27AaYWTg?si=M0Kqz6gRh-Io63l7",
      //embedUrl: "https://www.youtube.com/embed/alhRICYq4zA?si=tOGbwk4XM5abbyNC",
      duration: "30:03",
      description: "Best students in Elektrotehnicka skola Prijedor, including me, talking about our projects and achievements.",
      date: "May 29, 2024"
    }
  ]
};

export const achievements = [
  {
    id: 1,
    title: "NASA Space Apps Challenge Grand Paris Hackathon",
    organization: "NASA",
    year: "2024",
    description: "Third place with AI-powered orbit tracker project called Orbitoscope, designed to monitor space debris and improve space safety",
    icon: "🏆",
    thumbnail: "/images/achievements/paris1.jpg",
    images: [
      "/images/achievements/paris1.jpg",
      "/images/achievements/paris2.jpg",
      "/images/achievements/paris3.jpg",
      "/images/achievements/paris4.jpg",
      "/images/achievements/paris5.jpg",
      "/images/achievements/PARIS6.jpg"
    ],
    //link: "https://www.spaceappschallenge.org/"
  },
  {
    id: 2,
    title: "NASA Space Apps Challenge Hackathon Lisbon",
    organization: "NASA",
    year: "2025",
    description: "Top 10 with innovative solution for shark tracking using satellite data",
    icon: "⭐",
    thumbnail: "/images/achievements/lisbon1.jpg",
    images: [
      "/images/achievements/lisbon1.jpg",
      "/images/achievements/lisbon2.jpg",
      "/images/achievements/lisbon3.jpg"
    ],
   // link: "https://www.spaceappschallenge.org/"
  },
  {
    id: 3,
    title: "Best Innovation Award",
    organization: "Savez inovatora BiH",
    year: "2023, 2024, 2025",
    description: "Multiple IoT and AI projects recognized for innovation and impact",
    icon: "💡",
    thumbnail: "/images/achievements/inost1.jpg",
    images: [
      "/images/achievements/inost1.jpg",
      "/images/achievements/inost2.jpg",
      "/images/achievements/inost3.jpg"
    ],
    //link: "#"
  },
  {
    id: 4,
    title: "Banja Luka Hackathon",
    organization: "MF Banka, ICBL Banja Luka",
    year: "2026",
    description: "Second place with AI-powered solution for improving customer service in banking, with AI agent that can answer customer questions and provide personalized recommendations",
    icon: "🤖",
    thumbnail: "/images/achievements/bl1.jpg",
    images: [
      "/images/achievements/bl1.jpg",
      "/images/achievements/bl2.jpg"
    ],
   // link: "#"
  },
  {
    id: 5,
    title: "Mtel App Competition", 
    organization: "Mtel",
    year: "2025",
    description: "Top 5 app in Bosnia and Herzegovina with our app Alerta, showcasing our innovative solution for emergency response systems.",
    icon: "📱",
    thumbnail: "/images/achievements/mtel1.jpg",
    images: [
      "/images/achievements/mtel1.jpg",
      "/images/achievements/mtel2.jpg",
      "/images/achievements/mtel3.jpg"
    ],
    //link: "https://apptakmicenje.mtel.ba/prethodni-ciklusi-pregled/8-m-tel-app-takmicenje"
  },
  {
    id: 6,
    title: "Mostar Hackathon",
    organization: "Mostar Innovation Center",
    year: "2024",
    description: "Participated in the Mostar Hackathon, showcasing our innovative solution for a local challenge.",
    icon: "💻",
    thumbnail: "/images/achievements/mostar1.jpg",
    images: [
      "/images/achievements/mostar1.jpg",
      "/images/achievements/mostar2.jpg",
      "/images/achievements/mostar3.jpg",
      "/images/achievements/mostar4.jpg"
    ],
    //link: "#"
  },
  {
    id: 7,
    title: "Food Connect - application project",
    organization: "UNDP BiH",
    year: "2024",
    description: "Developed a mobile application to connect local food producers with consumers, improving the distribution of fresh produce.",
    icon: "🍔",
    thumbnail: "/images/achievements/foodconnect1.jpg",
    images: [
      "/images/achievements/foodconnect1.jpg",
      "/images/achievements/foodconnect2.jpg",
      "/images/achievements/foodconnect3.jpg"
    ],
    //link: "#"
  },
  {
    id: 8,
    title: "HKTN26 Hackathon — 1st Place",
    organization: "Codeference 2026",
    year: "2026",
    location: "Zlatibor, Serbia",
    icon: "🏆",
    description:
      "First place at the HKTN26 Hackathon during Codeference 2026. Our team developed a web-based energy management solution for small and medium-sized businesses, combining digital twin technology, AI-powered energy forecasting and actionable recommendations. The prize includes mentorship and support to further develop our solution and work towards launching a startup.",
    thumbnail: "/images/achievements/smartgrid1.jpg",
    images: [
      "/images/achievements/smartgrid5.jpg",
      "/images/achievements/smartgrid4.jpg",
      "/images/achievements/smartgrid1.jpg",
      "/images/achievements/smartgrid2.png",
    ],
    link: "https://dejanstanojevic.com/smartgrid/index.html"
  }

  
];

export const testimonials = [
  {
    id: 1,
    name: "Srđan Dukić",
    role: "CEO at Influence",
    content: "One of the most talented developers I've worked with. His attention to detail and problem-solving skills are exceptional. Dejan consistently delivers high-quality work and brings innovative ideas to the table.",
    avatar: "👨‍💼",
    rating: 5,
    linkedin: "#"
  },
  {
    id: 2,
    name: "Zorica Petrović",
    role: "Product Manager at Divas",
    content: "Delivered complex project ahead of schedule. His technical expertise and communication skills are top-notch. A true professional who takes ownership of his work.",
    avatar: "👩‍💼",
    rating: 5,
    linkedin: "#"
  },
  {
    id: 3,
    name: "Dražen Brđanin",
    role: "Professor at Electrical Engineering Faculty",
    content: "Dejan is an outstanding student with a passion for learning and innovation. His dedication to his projects and his ability to apply theoretical knowledge to practical solutions is impressive.",
    avatar: "👨‍🏫",
    rating: 5,
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "Building AI-Powered Applications with Python",
    excerpt: "Learn how to integrate machine learning models into your web applications using Python and modern frameworks.",
    date: "Mar 15, 2024",
    readTime: "8 min read",
    category: "AI/ML",
    image: "🤖",
    link: "#"
  },
  {
    id: 2,
    title: "The Future of Web Development: 2024 Trends",
    excerpt: "Exploring emerging trends and technologies shaping the web in 2024, from AI integration to WebAssembly.",
    date: "Mar 10, 2024",
    readTime: "6 min read",
    category: "Trends",
    image: "🚀",
    link: "#"
  },
  {
    id: 3,
    title: "React Native vs Flutter: What to Choose in 2024",
    excerpt: "A comprehensive comparison of the two leading cross-platform mobile development frameworks.",
    date: "Feb 28, 2024",
    readTime: "10 min read",
    category: "Mobile",
    image: "📱",
    link: "#"
  }
];